import {
  FaChartLine,
  FaCog,
  FaCoins,
  FaCrown,
  FaHeart,
  FaHistory,
  FaHome,
  FaLink,
  FaMoon,
  FaSun,
  FaSyncAlt,
  FaUser,
  FaClipboardList,
} from "react-icons/fa";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthProvider";
import { useProfiles } from "../../context/ProfilesProvider";
import { useTheme } from "../../context/ThemeProvider";
import { useUserConfig } from "../../context/UserConfigProvider";

interface MenuItem {
  name: string;
  path: string;
  subTitle?: string;
  icon?: React.ReactElement;
}

const Navigation = () => {
  const { logout, isAuthenticated, user } = useAuth();
  const { discordProfile, cbProfile } = useProfiles();
  const { theme, toggleTheme } = useTheme();
  const { permissions } = useUserConfig();
  const navigate = useNavigate();

  const isMod = permissions.isMod;

  const closeDrawer = () => {
    const drawerCheckbox = document.getElementById(
      "my-drawer-3",
    ) as HTMLInputElement;
    if (drawerCheckbox) {
      drawerCheckbox.checked = false;
    }
  };
  const navigateToHome = () => {
    navigate("/");
  };

  const broadcasterMenuItems: MenuItem[] = [
    { name: "Home", path: "/" },
    { name: "Community", path: "/community" },
    { name: "Offline Tip Menu", path: "/custom-tip-menu" },
    { name: "Top Tippers", path: "/top-tippers" },
    { name: "Tip Statistics", path: "/tip-statistics" },
    { name: "Deny Wars", path: "/deny-wars" },
    { name: "Settings", path: "/settings" },
  ];
  const userMenuItems: MenuItem[] = [
    { name: "Home", path: "/home", icon: <FaHome /> },
    { name: "Link Accounts", path: "/link-accounts", icon: <FaLink /> },
    { name: "Settings", path: "/my-settings", icon: <FaCog /> },
  ];
  const menuItems = user?.isBroadcaster ? broadcasterMenuItems : userMenuItems;

  // need to check if we should add nav menu items.
  if (user && !user?.isBroadcaster) {
    // if cb is linked
    if (cbProfile) {
      menuItems.push({
        name: "CB Tipper Profile",
        path: "/tipper-profile",
        icon: <FaUser />,
      });
    }
    // if discord profile exists
    if (discordProfile) {
      menuItems.push({
        name: "Shop Crim Coins",
        path: "/shop-crimcoins",
        icon: <FaCoins />,
      });

      menuItems.push({
        name: "Purchase History",
        subTitle: "(Coming Soon)",
        path: "#",
        icon: <FaHistory />,
      });

      menuItems.push({
        name: "Crimson Kitten's Menu",
        path: "/crimson-menu",
        icon: <FaHeart />,
      });

      menuItems.push({
        name: "My Subscriptions",
        path: "/my-subscriptions",
        icon: <FaSyncAlt />,
      });
    }
  }

  // Add chips leaderboard if broadcaster or mod
  if (user?.isBroadcaster || isMod) {
    menuItems.push({
      name: "CB Tip Menu",
      path: "/tip-menu-editor",
      icon: <FaHeart />,
    });
    menuItems.push({
      name: "Chips Leaderboard",
      path: "/chips-leaderboard",
      icon: <FaCoins />,
    });
    menuItems.push({
      name: "VIP Members",
      path: "/vip-members",
      icon: <FaCrown />,
    });
    menuItems.push({
      name: "Tip Queue",
      path: "/tip-queue",
      icon: <FaClipboardList />,
    });
    menuItems.push({
      name: "Broadcaster Dashboard",
      path: "/broadcaster-dashboard",
      icon: <FaChartLine />,
    });
  }

  return (
    <div className="drawer">
      <input id="my-drawer-3" type="checkbox" className="drawer-toggle" />
      <div className="drawer-content h-screen flex flex-col bg-base-100">
        {/* Navbar */}
        <div className="flex w-full navbar bg-base-300 ">
          <div className="flex-none">
            {isAuthenticated ? (
              <label
                htmlFor="my-drawer-3"
                aria-label="open sidebar"
                className="btn btn-square btn-ghost"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  className="inline-block w-6 h-6 stroke-current"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  ></path>
                </svg>
              </label>
            ) : null}
          </div>
          <div
            className="flex-1 px-2 mx-2 text-primary hover:cursor-pointer"
            onClick={() => navigateToHome()}
          >
            Reinstorm.io
          </div>
          <div className="flex-none">
            <button
              onClick={toggleTheme}
              className="btn btn-ghost btn-circle"
              aria-label="Toggle theme"
            >
              {theme === "light" ? (
                <FaMoon className="w-5 h-5" />
              ) : (
                <FaSun className="w-5 h-5" />
              )}
            </button>
          </div>
        </div>
        {/* Page content here */}
        <div className="overflow-y-auto flex flex-grow flex-col bg-base-200 w-full">
          <div className="flex flex-grow flex-col w-full max-w-7xl mx-auto">
            <Outlet />
          </div>
        </div>
      </div>

      <div className="drawer-side z-50">
        <label
          htmlFor="my-drawer-3"
          aria-label="close sidebar"
          className="drawer-overlay"
        ></label>
        <div className="menu p-4 w-80 min-h-full bg-base-200 flex flex-col">
          {/* enter pages here*/}
          <div className="flex-grow flex-col flex items-start w-full gap-4">
            {menuItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className="text-lg w-full text-left hover:text-primary justify-between flex flex-row border-b-2 border-base-100"
                onClick={closeDrawer}
              >
                <div className="flex flex-col">
                  <div>{item.name}</div>
                  <div className="text-xs text-secondary">{item.subTitle}</div>
                </div>

                {item.icon}
              </Link>
            ))}
          </div>
          <div
            className="btn btn-error"
            onClick={() => {
              closeDrawer();
              logout();
            }}
          >
            Logout
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navigation;
